import { Stack } from "@mui/material";
import * as React from "react";
import FuelCardsReportsTable from "../tables/FuelCardsReportsTable";
import FuelCardsReportsFilter from "../filters/FuelCardsReportsFilter";

function FuelCardsReports() {

    return (
        <Stack direction={"column"} spacing={2} margin={"16px"}>
            <FuelCardsReportsFilter/>
            <FuelCardsReportsTable/>
        </Stack>
    )
}

export default FuelCardsReports;